<template>
  <div class="w-full">
    <div class="hero w-full">
      <h1
        class="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8 text-2xl sm:text-4xl md:text-6xl font-bold uppercase text-center italic text-white"
      >
        Честно про сайты для заработка на просмотрах видео, лайках,
        комментариях...
      </h1>
    </div>
    <div class="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8 text-lg md:text-xl">
      <p>В наше нелегкое время все больше людей ищут для себя какой-то дополнительный заработок.
        Читая объявления и публикации в интеренете они все чаще попадают на рекламу таких "загадочных"
        видов заработка как просмотр видео в youtube, заработок на написании комментариев, на проставлении лайков и подобных.
      </p>
      <p class="mt-2">Этот сайт создан с целью разъяснить основные моменты по таким видам заработка в интернете.
        На сайте есть ответы на ниболее интересующие обывателя вопросы по данной теме, а также обзоры на популярные интерент
        ресурсы предлагающие заработать подобным образом. Те, кто захотят попробовать - найдут для себя здесь полезные советы,
        ссылки и лайфхаки связанные с данным заработком. 
      </p>
      <p class="mt-2">
        Все обзоры на этом сайте написаны исходя из личного опыта. Оценки и выводы по каждому интеренет ресурсу
        носят исключительно субъективный характер.
      </p>
      <div class="flex justify-center flex-wrap">
        <router-link class="text-blue-800 hover:text-blue-600 mt-2 mx-2" to="/about">Общие вопросы</router-link>
        <router-link class="text-blue-800 hover:text-blue-600 mt-2 mx-2" to="/summaries">Обзоры на сайты</router-link>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "home",
  components: {
  },
};
</script>

<style scoped lang="scss">
.hero {
  position: relative;
  background-image: url("~@/assets/hero.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.5);
  h1 {
    position: relative;
    z-index: 1;
    line-height: 1.2;
    text-shadow: 2px 2px 2px #000;
  }
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }
}
p {
  text-indent: 1rem;
}
</style>
